<ng-template #userProfileTemplate>
  <vex-page-layout>
    <vex-page-layout-header></vex-page-layout-header>

    <vex-page-layout-content class="-mt-6">
      <div class="card overflow-auto -mt-16">
        <!-- TABLE HEADER -->
        <base-data-table-header
          label="Annuaire"
          [loading]="loading"
          [showSearch]="true"
          [showArchives]="canShowArchivesPermission"
          [showArchived]="isArchive"
          (onSearchChange)="onSearchChange($event)"
          (onShowArchived)="onShowArchived($event)"
          (onClearTextFilter)="clearTextFilter()"
          (onCreate)="createItem()"
          [canCreate]="true"
          [canImport]="true"
          [canExport]="true"
          (onImport)="importItem()"
          (onExport)="exportItem()"
          [createPermission]="[permission.CREATE_INTERNAL_CONTACT]"
          [importPermission]="[permission.CREATE_INTERNAL_CONTACT]"
          [exportPermission]="[permission.READ_INTERNAL_CONTACT]"
          [templates]="[{ template: advancedFilters, position: 2, place: 'before' }]"
        ></base-data-table-header>

        <!-- TABLE DATA -->
        <base-data-table
          [count]="count"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [sortField]="sortField"
          [sortOrder]="sortOrder"
          [dataSource]="dataSource"
          [displayedColumns]="displayedColumns"
          [feisColumns]="feisColumns"
          [routerLinkDetailRow]="routerLinkDetailRow"
          [stickyTop]="true"
          [rowPermissionBlock]="[permission.READ_INTERNAL_CONTACT]"
          (onPageEvent)="pageEvent($event)"
          (onSortEvent)="sortEvent($event)"
          (onUpdateItem)="updateItem($event)"
          (onDeleteItem)="deleteItem($event)"
          (onArchiveItem)="archiveItem($event)"
        ></base-data-table>
      </div>
    </vex-page-layout-content>
  </vex-page-layout>

  <ng-template #advancedFilters>
    <button-filter [nbFilters]="activeFiltersCount" (clickButton)="toggleSidenav()"></button-filter>
  </ng-template>
</ng-template>

<ng-template #filtersTemplate>
  <ng-container *ngIf="isFilterOpen">
    <user-profile-filter
      [sidenav]="sideNav"
      [filters]="filters"
      (onClear)="clearTextFilter()"
      (onFilter)="applyAdvancedFilter($event)"
    ></user-profile-filter>
  </ng-container>
</ng-template>

<app-sidenav #sidenav [content]="userProfileTemplate" [contentSidenav]="filtersTemplate"></app-sidenav>
